// Firma bilgileri — çıktı formlarında imza alanı ve firma başlıklarında kullanılır.
// Backend'deki settings/company kaydı boşsa ya da PDF/çıktı üretilirken varsayılan gerekliyse burası referans alınır.
export const COMPANY_NAME = "HİLAL PLASPER PLASTİK AMBALAJ SAN. VE TİC. LTD. ŞTİ.";
export const COMPANY_SHORT = "Plasper Ambalaj";
